import React, { createContext, useContext, useEffect, useMemo, useState } from 'react';
import { API_BASE_URL } from '../frontend_config';

const CapabilitiesContext = createContext(null);

export const useCapabilities = () => {
  const ctx = useContext(CapabilitiesContext);
  if (!ctx) {
    throw new Error('useCapabilities must be used within a CapabilitiesProvider');
  }
  return ctx;
};

export const CapabilitiesProvider = ({ children }) => {
  const [capabilities, setCapabilities] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let mounted = true;

    const loadCapabilities = async () => {
      setLoading(true);
      setError(null);

      try {
        const res = await fetch(`${API_BASE_URL}/api/system/capabilities`);
        if (!res.ok) {
          throw new Error(`Capabilities request failed: ${res.status}`);
        }
        const data = await res.json();
        if (mounted) {
          setCapabilities(data);
        }
      } catch (e) {
        if (mounted) {
          setCapabilities(null);
          setError(e);
        }
      } finally {
        if (mounted) {
          setLoading(false);
        }
      }
    };

    loadCapabilities();

    return () => {
      mounted = false;
    };
  }, []);

  const value = useMemo(() => {
    const modules = capabilities?.modules || {};

    return {
      capabilities,
      loading,
      error,
      isModuleEnabled: (moduleKey) => modules[moduleKey] === true,
    };
  }, [capabilities, loading, error]);

  return (
    <CapabilitiesContext.Provider value={value}>
      {children}
    </CapabilitiesContext.Provider>
  );
};

export default CapabilitiesContext;
